import React from "react";

import Rede1 from "../../../assets/images/rede1.png";
import Dinamico from "../../../assets/images/dinamico.png";
import Wifi2 from "../../../assets/images/wifi2.png";
import Wifi2Security from "../../../assets/images/wifi2Security.png";
import Wifi5 from "../../../assets/images/wifi5.png";
import Wifi5Security from "../../../assets/images/wifi5Security.png";
import DhcpDns from "../../../assets/images/dhcp.png";
import Reiniciar from "../../../assets/images/reiniciar.png";
import RouterConfig from "../../../assets/images/router.png";


import './styles.css';

const ModoRouter = () => {

    return (

        <>
            <div className="content">
                
                <h1>Cenário I Roteador em modo Router</h1>
                <span>
                    A figura abaixo ilustra uma configuração comum para residências, ideal para controlar os roteadores
                    através  nosso aplicativo de gerenciamento de redes.
                </span>
                <div className="rede1">
                    <img src={Rede1} alt="rede" />
                </div>
                <span>
                    Neste cenário acima, foi empregado o IP Dinâmico, no qual a ONU atribui dinamicamente o endereço IP 192.168.100.2 por meio do servidor DHCP incorporado na ONU.
                    Observe que o roteador também está com o servidor DHCP ativado para distribuir endereços IP para os demais dispositivos.
                </span>
                <br />
                <h1>Configuração do cenário apresentado:</h1>
                <div className="router">
                    <img src={RouterConfig} alt="router" />
                </div>
                <br />
                <div className="dinamico">
                    <img src={Dinamico} alt="dinamico" />
                </div>
                <br />
                <p>Configurando o SSID da Wi-FI 2.4GHz</p>
                <div className="wifi2">
                    <img src={Wifi2} alt="wifi2" />
                </div>
                <br />
                <p>Configurando a Segurançada Wi-FI 2.4GHz</p>
                <div className="wifi2">
                    <img src={Wifi2Security} alt="wifi2" />
                </div>
                <br />
                <p>Configurando o SSID da Wi-FI 5GHz</p>
                <div className="wifi5">
                    <img src={Wifi5} alt="wifi5" />
                </div>
                <br />
                <p>Configurando a Segurança da Wi-FI 5GHz</p>
                <div className="wifi5">
                    <img src={Wifi5Security} alt="wifi5" />
                </div>
                <br />
                <p>Configurando o servidor DHCP e DNS</p>
                <div className="dns">
                    <img src={DhcpDns} alt="dns" />
                </div>
                <br />
                <p>Reinicie o roteador, conecte o cabo de rede na porta 1 da ONU na porta WAN do roteador. Realize um teste de navagação com o celular para verificar se as configurações foram aplicadas corretamente.</p>
                <div className="dns">
                    <img src={Reiniciar} alt="dns" />
                </div>
            </div>

        </>
    );
};
export default ModoRouter;